import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate, Link} from "react-router-dom";
import { EyeIcon, EyeOffIcon } from "lucide-react";

const Register = () => {
  const [formData, setFormData] = useState({
    username: "",
    name: "",
    email: "",
    password: "",
    pass_confirm: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Registrasi Berhasil",
          text: "Akun kamu menunggu persetujuan admin.",
        });
        setFormData({
          username: "",
          name: "",
          email: "",
          password: "",
          pass_confirm: "",
        });
      } else {
        // cek apakah CI4 kirim errors
        let errorMessage = "";
        if (data.errors) {
          // versi jika CI4 kirim "errors"
          errorMessage = Object.values(data.errors).join("<br>");
        } else if (data.messages) {
          // versi sesuai hasil JSON yang kamu screenshot
          errorMessage = Object.values(data.messages).join("<br>");
        } else if (data.message) {
          errorMessage = data.message;
        } else {
          errorMessage = `Terjadi kesalahan (status ${response.status})`;
        }

        Swal.fire({
          icon: "error",
          title: "Failed",
          html: errorMessage,
        });
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 bg-white shadow-md p-6 rounded">
      <div className="flex justify-center w-full p-8">
        <img src="/v2/images/mxm-with-label.png" alt="MXM Logo" />
      </div>
           
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block">Username</label>
          <input
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>
        <div>
          <label className="block">Nama Lengkap</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>
        <div>
          <label className="block">Email</label>
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>
        <div>
          <label className="block">Password</label>
          <div className="relative">
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full border px-3 py-2 rounded"
            />
            <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
            </button>
          </div>
        </div>
        <div>
          <label className="block">Konfirmasi Password</label>
          <div className="relative">
            <input
              name="pass_confirm"
              type={showConfPassword ? "text" : "password"}
              value={formData.pass_confirm}
              onChange={handleChange}
              required
              className="w-full border px-3 py-2 rounded"
            />
            <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                onClick={() => setShowConfPassword(!showConfPassword)}
              >
                {showConfPassword ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
            </button>
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-black/100 text-white py-2 rounded hover:bg-black/70"
        >
          {loading ? "Mendaftarkan..." : "Daftar"}
        </button>
      </form>
      <div className="py-4">
        <Link
          className="text-blue-600 text-underline-offset"
            to="/login"
            >
            Sudah punya akun? Login
            </Link>
        </div>
    </div>
  );
};

export default Register;
